export default function Marquee() {
  const items = [
    'PREMIUM KESİM', 'ÖZEL BAKIM', 'VIP DENEYİM', 'UZMAN DOKUNUŞ',
    'PREMIUM KESİM', 'ÖZEL BAKIM', 'VIP DENEYİM', 'UZMAN DOKUNUŞ'
  ];

  return (
    <div className="marquee-wrap">
      <div className="marquee-track">
        {items.map((item, i) => (
          <span key={i} className="marquee-item">
            <span className="marquee-text">{item}</span>
            <span className="marquee-diamond" />
          </span>
        ))}
      </div>
    </div>
  );
}
